// Import SVG images
import completedSvg from '../../../media/images/completed-status.svg';
import cancelledSvg from '../../../media/images/cancelled-status.svg';
import inProgressSvg from '../../../media/images/in-progress.svg';
import todoSvg from '../../../media/images/todo.svg';

/**
 * Get priority variant for styling
 * @param {string} priority - Priority level
 * @returns {string} Variant for styling
 */
export const getPriorityVariant = priority => {
  const priorityLower = priority ? priority.toLowerCase() : 'medium';
  switch (priorityLower) {
    case 'high':
      return 'danger';
    case 'medium':
      return 'warning';
    case 'low':
      return 'info';
    default:
      return 'warning';
  }
};

// Function to get status image based on status
export const getStatusImage = status => {
  switch (status) {
    case 'completed':
      return completedSvg;
    case 'cancelled':
      return cancelledSvg;
    case 'in-progress':
      return inProgressSvg;
    default:
      return todoSvg;
  }
};

export const getStatusLabel = status => {
  switch (status) {
    case 'completed':
      return 'Completed';
    case 'cancelled':
      return 'Cancelled';
    case 'in-progress':
      return 'In Progress';
    default:
      return 'To Do';
  }
};

export const toAmountString = amount => {
  if (amount === null || amount === undefined) return '';
  if (amount < 0) return `-$${Math.abs(amount).toLocaleString()}`;
  return `$${amount.toLocaleString()}`;
};

export const processTaskValue = value => {
  // Check if we're in QA environment
  if (
    process.env.REACT_APP_ENV === 'qa' &&
    value &&
    typeof value === 'string'
  ) {
    // Remove the word 'balance' (case insensitive) from the task value
    return value.replace(/balance\s*/i, '');
  }
  return value;
};

export const extractPriorityFromDescription = description => {
  if (!description) return 'Medium'; // Default priority

  const priorityMatch = description.match(/Priority:\s*(High|Medium|Low)/i);
  return priorityMatch ? priorityMatch[1] : 'Medium';
};

export const mergeUsersToTasks = (tasks = [], users = []) => {
  if (!tasks.length || !users.length) {
    return tasks;
  }

  // Create a map with both string and number keys to handle type mismatches
  const usersMap = users.reduce((acc, user) => {
    const userId = user.user_id_id;
    // If userId is a number, add both number and string keys
    if (typeof userId === 'number') {
      acc[userId] = user;
      acc[String(userId)] = user;
      // If userId is a string and is numeric, add both string and number keys
    } else if (typeof userId === 'string') {
      const trimmedUserId = userId.trim();
      if (trimmedUserId !== '' && !isNaN(trimmedUserId)) {
        acc[trimmedUserId] = user;
        acc[Number(trimmedUserId)] = user;
      } else {
        acc[userId] = user;
      }
      // Otherwise, just add the original value
    } else {
      acc[userId] = user;
    }
    return acc;
  }, {});

  return tasks.map(task => {
    const assignedUser = usersMap[task.assigned_to_id];
    return {
      ...task,
      assignedUser,
    };
  });
};
